// removed by extract-text-webpack-plugin
module.exports = {"PCard":"_16NORHSDxyqShU_pdxFCeR","img":"_16D7GSJ0NaYxV27ececO_d","noImg":"VuNiAUfF8Cz3FC7iCtHDG","boxInfo":"_1G_neK4kVp_JCW3e03EjYr","name":"_1uZs6bYq-bszX8kX4tSz-t","price":"_2hiTpoNOBzY_96VXCe5WwC","newPrice":"wpo50pemB757RSAQqyhZK","oldPrice":"_1F0LA1XbOTUsNutIywyNHz","nameShop":"_1yhr_UAfbELi9vOH4NTAxj","address":"_3yiNBTcq3fBKpY7lDDNopr","timeExpire":"_3e20IJyofGBxPbysEsQPZA"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/PCard.scss
// module id = 452
// module chunks = 0